import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { Status } from "../../../common/constants";
import { denyAlertUrl } from "../../../config";
import api from "../../../api";
import { IInitialSliceState } from "../../../common/types/commonTypes";

const DENY_ALERT: string = "denyAlert"

const initialState: IInitialSliceState = {
  status: Status.IDLE,
  error: null,
  msg: null,
};

export const denyAlert = createAsyncThunk(DENY_ALERT, async (payload: string[], { rejectWithValue }) => {
    try {
      const response = await api.put(denyAlertUrl,{subscriptionIds:payload});
      const denyAlertResponse = response.data;
      return denyAlertResponse;
    } catch (error) {
      throw rejectWithValue(error);
    }
  }
);

const denyAlertSlice = createSlice({
  name: DENY_ALERT,
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
        builder
            .addCase(denyAlert.pending, (state) => {
                state.status = Status.PENDING;
            })
            .addCase(denyAlert.fulfilled, (state, action) => {
                state.status = Status.SUCCESS;
                state.msg = action.payload.message;
            })
            .addCase(denyAlert.rejected, (state, action) => {
                const errorPayload = action.payload as { response?: { data?: { error?: { message?: string }, message?: string } } };
                state.msg = errorPayload.response?.data?.error?.message || errorPayload.response?.data?.message || 'Unknown error occurred';
                state.status = Status.FAILED;
            });
    },
});

type Selector = {
  denyAlertApi: ReturnType<
    typeof denyAlertSlice.reducer
  >;
};

export const selector = (store: Selector) => store['denyAlertApi'];

export default denyAlertSlice.reducer;